import React from 'react';
import Icon from '../../../components/AppIcon';

const QuickActionsGrid = ({ onAction }) => {
  const actions = [
    {
      id: 'upload-analysis',
      title: 'Analyze Resume',
      description: 'Upload and analyze your resume',
      icon: 'Upload',
      color: 'bg-blue-500',
      badge: null
    },
    {
      id: 'ai-chat',
      title: 'AI Career Chat',
      description: 'Get personalized advice',
      icon: 'MessageSquare',
      color: 'bg-purple-500',
      badge: 'New'
    },
    {
      id: 'skill-gaps',
      title: 'Skill Analysis',
      description: 'Bridge your skill gaps',
      icon: 'Target',
      color: 'bg-orange-500',
      badge: null
    }
  ];

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold text-card-foreground">Quick Actions</h3>
        <Icon name="Zap" size={20} className="text-primary" />
      </div>
      
      <div className="space-y-3">
        {actions.map((action) => (
          <button
            key={action.id}
            onClick={() => onAction(action.id)}
            className="w-full flex items-center space-x-3 p-3 rounded-lg border border-border hover:border-primary hover:bg-primary/5 transition-all duration-200 group"
          >
            <div className={`flex-shrink-0 w-10 h-10 ${action.color} rounded-lg flex items-center justify-center group-hover:scale-110 transition-transform`}>
              <Icon name={action.icon} size={18} color="white" />
            </div>
            
            <div className="flex-1 text-left">
              <div className="flex items-center space-x-2">
                <h4 className="text-sm font-semibold text-card-foreground group-hover:text-primary transition-colors">
                  {action.title}
                </h4>
                {action.badge && (
                  <span className="text-xs px-2 py-0.5 bg-purple-100 text-purple-700 rounded-full font-medium">
                    {action.badge}
                  </span>
                )}
              </div>
              <p className="text-xs text-muted-foreground mt-0.5">
                {action.description}
              </p>
            </div>
            
            <Icon name="ChevronRight" size={16} className="text-muted-foreground group-hover:text-primary group-hover:translate-x-1 transition-all" />
          </button>
        ))}
      </div>
    </div>
  );
};

export default QuickActionsGrid;